const CONFIG = {
  workflow: {
    display: [
      {
        label: 'Start',
        data: [
          {
            label: 'Create',
            readonly: true,
            hideStateIcons: true,
            users: [],
            transition: 'create'
          }
        ]
      },
      {
        label: 'Cost estimate',
        data: [
          {
            label: 'Raw materials',
            users: [],
            key: 'submit_cost_estimate:materials',
            transition: 'submit_cost_estimate',
            context: { sub: 'materials' }
          },
          {
            label: 'Electronic engineering',
            users: [],
            key: 'submit_cost_estimate:ee.activities',
            transition: 'submit_cost_estimate',
            context: { sub: 'ee.activities' }
          },
          {
            label: 'Mechanical engineering',
            users: [],
            key: 'submit_cost_estimate:me.activities',
            transition: 'submit_cost_estimate',
            context: { sub: 'me.activities' }
          },
          {
            label: 'Assembly',
            users: [],
            key: 'submit_cost_estimate:assembly.activities',
            transition: 'submit_cost_estimate',
            context: { sub: 'assembly.activities' }
          },
          {
            label: 'Supply chain',
            users: [],
            key: 'submit_cost_estimate:scm.activities',
            transition: 'submit_cost_estimate',
            context: { sub: 'scm.activities' }
          },
          {
            label: 'Warehousing',
            users: [],
            key: 'submit_cost_estimate:warehouse.activities',
            transition: 'submit_cost_estimate',
            context: { sub: 'warehouse.activities' }
          },
          {
            label: 'Logistics',
            users: [],
            key: 'submit_cost_estimate:logistics.activities',
            transition: 'submit_cost_estimate',
            context: { sub: 'logistics.activities' }
          },
          {
            label: 'Quality control',
            users: [],
            key: 'submit_cost_estimate:qc.activities',
            transition: 'submit_cost_estimate',
            context: { sub: 'qc.activities' }
          },
          {
            label: 'Project management',
            users: [],
            key: 'submit_cost_estimate:pm.activities',
            transition: 'submit_cost_estimate',
            context: { sub: 'pm.activities' }
          },
          {
            label: 'Cost approval',
            key: 'cost_estimate_approval',
            transition: 'approve_cost_estimate',
            approval_name: 'cost_approval',
            users: [],
            buttons: [
              {
                label: 'Approve',
                type: 'primary',
                transition: 'approve_cost_estimate',
                message: 'Approved.',
                state: 'approved'
              },
              {
                label: 'Reject',
                type: 'error',
                transition: 'reject_cost_estimate',
                message: 'Reject.',
                state: 'rejected'
              },
              {
                label: 'Remind',
                type: 'warning',
                transition: 'remind_cost_estimate',
                message: 'Remind.',
                state: 'reminded'
              }
            ]
          }
        ]
      },
      {
        label: 'Margin',
        data: [
          {
            label: 'Add margin',
            users: [],
            key: 'sales-submit_margin',
            transition: 'submit_margin'
          },
          {
            label: 'Finance approval',
            users: [],
            key: 'approve_margin:finance',
            transition: 'approve_margin',
            approval_name: 'finance_approval',
            context: { sub: 'finance' },
            buttons: [
              {
                label: 'Approve',
                type: 'primary',
                transition: 'approve_margin:finance',
                message: 'Approved.',
                state: 'approved'
              },
              {
                label: 'Reject',
                type: 'error',
                transition: 'reject_margin:finance',
                message: 'Rejected.',
                state: 'rejected'
              },
              {
                label: 'Remind',
                type: 'warning',
                transition: 'remind_margin:finance',
                message: 'Reminded.',
                state: 'reminded'
              }
            ]
          },
          {
            label: 'Approval',
            users: [],
            key: 'approve_margin:sales_manager',
            transition: 'approve_margin',
            approval_name: 'margin_approval',
            context: { sub: 'sales_manager' },
            buttons: [
              {
                label: 'Approve',
                type: 'primary',
                transition: 'approve_margin:sales_manager',
                message: 'Approved.',
                state: 'approved'
              },
              {
                label: 'Reject',
                type: 'error',
                transition: 'reject_margin:sales_manager',
                message: 'Rejected.',
                state: 'rejected'
              },
              {
                label: 'Remind',
                type: 'warning',
                transition: 'remind_margin:sales_manager',
                message: 'Reminded.',
                state: 'reminded'
              }
            ]
          },
          {
            label: 'Final approval',
            users: [],
            key: 'approve_margin:gm',
            transition: 'approve_margin',
            approval_name: 'final_approval',
            context: { sub: 'gm' },
            buttons: [
              {
                label: 'Approve',
                type: 'primary',
                transition: 'approve_margin:gm',
                message: 'Approved.',
                state: 'approved'
              },
              {
                label: 'Reject',
                type: 'error',
                transition: 'reject_margin:gm',
                message: 'Rejected.',
                state: 'rejected'
              },
              {
                label: 'Remind',
                type: 'warning',
                transition: 'remind_margin',
                message: 'Reminded.',
                state: 'reminded'
              }
            ]
          }
        ]
      }
    ]
  }
}

export default CONFIG
